import { api } from '@/api/client';

export interface FieldSalesRepresentativeCompany {
  id: string;
  parent_id: string | null;
  name: string;
  street: string;
  zip_code: string;
  city: string;
  country_id: string;
  uid_number: string;
  is_active: boolean;
  level_id: string | null;
  company_since: string | null;
  tax_id: string | null;
  email: string | null;
  phone_number: string | null;
  customer_id: string | null;
  updated_at: string;
}

export interface FieldSalesRepresentativeContact {
  id: string;
  company_id: string;
  first_name: string;
  last_name: string;
  phone_number: string | null;
  email: string | null;
  is_active: boolean;
  is_primary_contact: boolean;
  user_id: string | null;
  user_role_id: string;
  updated_at: string;
}

export interface FieldSalesRepresentativeCompanyAndContact {
  company: FieldSalesRepresentativeCompany;
  contact: FieldSalesRepresentativeContact;
}

export interface CreateFieldSalesRepresentativeRequest {
  customerCompanyId: string;
  companyContactId: string;
}

// Joins a representative contact's first and last name into a display name.
export function contactDisplayName(contact: FieldSalesRepresentativeContact) {
  return `${contact.first_name} ${contact.last_name}`.trim();
}

export interface FieldSalesRepresentativeLink {
  id: string;
  companyId: string;
  customerCompanyId: string;
  companyContactId: string;
  createdAt: string;
}

export function fetchFieldSalesRepresentativesAsCustomer(
  customerCompanyId: string
): Promise<FieldSalesRepresentativeCompanyAndContact[]> {
  return api.get<FieldSalesRepresentativeCompanyAndContact[]>(
    `/v1/companies/${customerCompanyId}/field-sales-representatives/as-customer`
  );
}

export function fetchFieldSalesRepresentatives(
  companyId: string,
  customerCompanyId: string
): Promise<FieldSalesRepresentativeContact[]> {
  return api.get<FieldSalesRepresentativeContact[]>(
    `/v1/companies/${companyId}/field-sales-representatives`,
    {
      params: {
        customerCompanyId,
      },
    }
  );
}

export function addFieldSalesRepresentative(
  companyId: string,
  request: CreateFieldSalesRepresentativeRequest
): Promise<FieldSalesRepresentativeLink> {
  return api.post<FieldSalesRepresentativeLink>(
    `/v1/companies/${companyId}/field-sales-representatives`,
    request
  );
}

export function removeFieldSalesRepresentative(
  companyId: string,
  customerCompanyId: string
): Promise<void> {
  return api.delete<void>(
    `/v1/companies/${companyId}/field-sales-representatives/${customerCompanyId}`
  );
}
